module.exports = "<span class=\"input-error promo--matched\" ng-bind-html=\"inlineMessage.message.promotionDescription\">\r\n</span>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/collectionzone/inline-messages/matched-promotion.html
 ** module id = 908
 ** module chunks = 1
 **/